import React, { useState } from "react";

import IconCheckbox from "../IconCheckbox";
import { sendFeatureFeedback } from "./featureFeedback";
import StorySheet from "./StorySheet";

export default function FeatureFeedbackSheet({ onClose, ...feedbackProps }) {
  const [message, setMessage] = useState("");
  const [includeAccountDetails, setIncludeAccountDetails] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [hasSent, setHasSent] = useState(false);
  const [hasError, setHasError] = useState(false);

  const send = async () => {
    setIsSending(true);
    setHasError(false);
    try {
      await sendFeatureFeedback({ ...feedbackProps, includeAccountDetails, message });
      setHasSent(true);
    } catch {
      setHasError(true);
    } finally {
      setIsSending(false);
    }
  };

  if (hasSent) {
    return (
      <StorySheet
        footer={<button className="btn btn-success btn-lg joystix story-sheet-primary" type="button" onClick={onClose}>Done</button>}
        testId="feature-feedback-sheet"
        title="Feedback"
        onClose={onClose}
      >
        <p className="story-feedback-prompt" data-testid="feature-feedback-thanks">Thanks for your feedback!</p>
      </StorySheet>
    );
  }

  return (
    <StorySheet
      footer={
        <button
          className="btn btn-success btn-lg joystix story-sheet-primary"
          data-testid="feature-feedback-send"
          disabled={!message.trim() || isSending}
          type="button"
          onClick={send}
        >
          Send
        </button>
      }
      testId="feature-feedback-sheet"
      title="Feedback"
      onClose={onClose}
    >
      <p className="text-muted">Share your thoughts on this feature or general feedback about Clozemaster.</p>
      {hasError && <p className="text-danger">Something went wrong. Please try again.</p>}
      <textarea
        autoFocus
        className="form-control"
        data-testid="feature-feedback-message"
        placeholder="Type your feedback here..."
        rows={5}
        value={message}
        onChange={(event) => setMessage(event.target.value)}
      />
      <IconCheckbox checked={includeAccountDetails} className="feature-feedback-account" onChange={() => setIncludeAccountDetails(!includeAccountDetails)}>
        <span>Include my account details so we can follow up</span>
      </IconCheckbox>
    </StorySheet>
  );
}
